import TncPage from "@/components/tnc/TncPage";
import { ewTncFooterNote, ewTncHero, ewTncSections } from "./tncContent";

export default function TermsAndConditions() {
  return (
    <TncPage
      hero={ewTncHero}
      sections={ewTncSections}
      footerNote={ewTncFooterNote}
      path="/izicart/extended/tnc"
    />
  );
}
